const API_STACK = 'report/';

export const GET_BASIC_PORTAL_STATS = API_STACK + 'portal/stats';
